module.exports = {
  en: require('./en.json')
};



//////////////////
// WEBPACK FOOTER
// ./lib/assets/javascripts/deep-insights/locale/index.js
// module id = 609
// module chunks = 0 2